/*
  德语
*/
export default {

}
